export default __webpack_public_path__ + "static/media/Lato-Black.0b51cf32.ttf";